import { Injectable } from '@angular/core';
import { ExpenseHead } from '../../interface/expensehead/expensehead';

import { HttpService } from '../http/http.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ExpenseheadService {

  constructor(private _expanseHeadService: HttpService) { }

  public async getAll(): Promise<ExpenseHead[]> {
    return firstValueFrom(this._expanseHeadService.get('/ExpenseHeads'));
  }
  public async get(id: number): Promise<ExpenseHead> {
    return firstValueFrom(this._expanseHeadService.get('/ExpenseHeads/' + id));
  }
  public async create(data: ExpenseHead): Promise<ExpenseHead> {
    return firstValueFrom(this._expanseHeadService.post('/ExpenseHeads', data));
  }
  public async update(id: number, data: ExpenseHead): Promise<ExpenseHead> {
    return firstValueFrom(this._expanseHeadService.patch('/ExpenseHeads/', id, data));
  }
  public async delete(id: number): Promise<void> {
    return firstValueFrom(this._expanseHeadService.delete('/ExpenseHeads/', id));
  }
}
